import {ChangeEvent} from "react";
interface IDocumentButton {
    icon: any;
    accept: string;
    classeName?: string;
    id: string;
    onSelect: any;
    multiple?: any;
}
export default function ImageButton({
                                           icon,
                                           accept,
                                           id,
                                           onSelect,
                                           classeName,
                                        multiple = true
}: IDocumentButton){

    function handleChange(event: ChangeEvent<HTMLInputElement>) {
        if (event.target.files === null) return;
        const files = Array.from(event.target.files);
        onSelect(files)
    }
    return(
        <div className={classeName}>
            <label
                htmlFor={id}
                className="flex flex-col  gap-2 cursor-pointer"
                title={'Adicionar imagem'}
            >
                {icon}
            </label>
            <input
                accept={accept}
                multiple={multiple}
                onChange={handleChange}
                id={id}
                type="file"
                className="hidden"
            />
        </div>
    )
}